import { render, staticRenderFns } from "./OrderDocumentActions.vue?vue&type=template&id=75dca124&"
import script from "./OrderDocumentActions.vue?vue&type=script&lang=ts&"
export * from "./OrderDocumentActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports